module.exports = __webpack_public_path__ + "img/icon5_normal.0aa80ed1.png";